/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { LeftSide } from './LeftSide'
import { RightSidebar } from './RightSidebar'
import TopBar from '../../../components/TopBar'
import UploadMediaPopup from '../../../components/UploadMediaPopup'
import { createProduct, updateProduct, deleteProducts, getCategoryBrand, getProduct } from '../../../api/productsApi'
import DeleteConfirmationPopup from '../../../components/DeleteConfirmationPopup'

import styles from '../page.module.css'

const NewProduct = () => {
    const { productId } = useParams();
    const navigate = useNavigate();
    const deletePopupRef = useRef()

    const [showUploadMediaPopup, setShowUploadMediaPopup] = useState(false);
    const [uploadMediaPopupFor, setUploadMediaPopupFor] = useState('');
    const [uploadMediaPopupTab, setUploadMediaPopupTab] = useState('upload');
    const [selectedFeatureImage, setSelectedFeatureImage] = useState(null);
    const [showDeletePopup, setShowDeletePopup] = useState(false);

    const [errors, setErrors] = useState({});

    const [productData, setProductData] = useState({
        title: '',
        description: '',
        shortDescription: '',
        seoContent: '',
        seoTitle: '',
        keyword: '',
        specification: [{ label: '', value: '' }],
        image: '',
        priceFrom: 0,
        priceTo: 0,
        status: 'draft',
        slug: '',
        sku: '',
        hsnCode: '',
        isTrackStock: false,
        quantity: 0,
        isPopular: false,
        isHotDeal: false,
        isShowInList: false,
        isBuilderChoice: false,
        isProPicks: false,
        isTrendingNow: false,
        unit: '',
        unitPlural: '',
        isServiceProduct: false
    })

    const [published, setPublished] = useState(false);
    const [draft, setDraft] = useState(false);
    const [isPublishedOpen, setIsPublishedOpen] = useState(false);
    const [isDraftOpen, setIsDraftOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isDraftLoading, setIsDraftLoading] = useState(false);
    const [isSlugChanged, setIsSlugChanged] = useState(false);
    const [categoryList, setCategoryList] = useState([])
    const [brandList, setBrandList] = useState([])
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [selectedBrandCategories, setSelectedBrandCategories] = useState({});
    const [selectedImageFileData, setSelectedImageFileData] = useState([]);
    const [selectedImagesValidate, setSelectedImagesValidate] = useState(false);
    const [selectedMedia, setSelectedMedia] = useState([])

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (deletePopupRef.current && !deletePopupRef.current.contains(event.target)) {
                setShowDeletePopup(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (uploadMediaPopupFor === 'feature-image' && selectedMedia?.length > 0) {
            setSelectedFeatureImage(selectedMedia[0])
            setProductData({
                ...productData,
                image: selectedMedia[0]?.id
            });
            setErrors({ ...errors, image: '' })
        } else if (uploadMediaPopupFor === 'images-file' && selectedMedia?.length > 0) {
            setSelectedImageFileData(selectedMedia)
            setProductData({
                ...productData,
                galleryImage: selectedMedia?.map(item => item?.id)?.filter(Boolean)
            });
        }

    }, [uploadMediaPopupFor, selectedMedia])

    const getSinglePage = async () => {
        try {
            const response = await getProduct(productId)
            if (response?.success) {
                const productItem = response?.data || {}
                setProductData({
                    ...response?.data,
                    image: response?.data?.image?.id || '',
                    galleryImage: response?.data?.galleryImage?.map(item => item?.id)?.filter(Boolean)
                })

                setSelectedFeatureImage(response?.data?.image)
                setSelectedImageFileData(response?.data?.galleryImage)

                const selectedCats = categoryList.filter(cat =>
                    productItem?.categoryId.includes(cat?.id)
                );

                const selectedBrand = brandList.find(
                    brand => brand?.id === productItem?.brandId
                );

                setSelectedCategories(selectedCats);
                setSelectedBrandCategories(selectedBrand || {});

                if (productItem?.status === "published") {
                    setPublished(true);
                    setDraft(false);
                } else if (productItem?.status === "draft") {
                    setDraft(true);
                    setPublished(false);
                }
            }
        } catch (error) {
            console.log({ error })
        }
    }

    useEffect(() => {
        if (productId && productId !== undefined && productId !== '' && categoryList?.length && brandList?.length) {
            getSinglePage()
        }
    }, [productId, categoryList, brandList])

    const fetchCategoryBrand = async () => {
        try {
            const response = await getCategoryBrand()
            if (response?.success) {
                setCategoryList(response?.data?.categories)
                setBrandList(response?.data?.brands)
            }
        } catch (error) {

        }
    }

    useEffect(() => {
        fetchCategoryBrand()
    }, [])

    function convertToSlug(str) {
        let slug = str.toLowerCase();

        slug = slug.trim();

        slug = slug.replace(/[^a-z0-9\s-]/g, '');

        slug = slug.replace(/\s+/g, '-');

        return slug;
    }

    const changeSlug = (value) => {
        setProductData(prev => ({
            ...prev,
            slug: convertToSlug(value)
        }));
    };

    const handleChange = (e) => {
        const { name, value } = e.target
        setProductData((prev) => ({
            ...prev,
            [name]: value,
        }))

        setErrors((prev) => ({
            ...prev,
            [name]: '',
        }))
    }

    const handleSpecificationChange = (index, field, value) => {
        setProductData((prev) => {
            const updatedSpecs = [...prev.specification];
            updatedSpecs[index][field] = value;
            return {
                ...prev,
                specification: updatedSpecs,
            };
        });
        setErrors(prev => {
            if (!prev?.specification) return prev;

            const updatedSpecErrors = [...prev.specification];

            if (updatedSpecErrors[index]) {
                updatedSpecErrors[index] = {
                    ...updatedSpecErrors[index],
                    [field]: '', // remove error
                };
            }

            return {
                ...prev,
                specification: updatedSpecErrors,
            };
        });
    };

    const addSpecification = () => {
        setProductData((prev) => ({
            ...prev,
            specification: [...prev.specification, { label: '', value: '' }],
        }));
    };

    const deleteSpecification = (index) => {
        setProductData((prev) => ({
            ...prev,
            specification: prev.specification.filter((_, i) => i !== index),
        }));
    };

    const validateProduct = () => {
        let newErrors = {};

        // Basic fields
        if (!productData?.title?.trim()) {
            newErrors.title = "Title is required";
        }

        if (!productData?.description?.trim()) {
            newErrors.description = "Description is required";
        }

        if (!productData?.shortDescription?.trim()) {
            newErrors.shortDescription = "Short description is required";
        }

        if (!productData?.seoContent?.trim()) {
            newErrors.seoContent = "SEO content is required";
        }
        if (!productData?.seoTitle?.trim()) {
            newErrors.seoTitle = "SEO Title is required";
        }
        if (!productData?.keyword?.trim()) {
            newErrors.keyword = "Keyword is required";
        }

        if (!productData?.slug?.trim()) {
            newErrors.slug = "URL is required";
        }
        if (!productData?.unit?.trim()) {
            newErrors.unit = "Unit is required";
        }
        if (!productData?.unitPlural?.trim()) {
            newErrors.unitPlural = "Unit Plural is required";
        }

        if (!productData?.sku?.trim()) {
            newErrors.sku = "SKU is required";
        }
        if (
            !productData?.image ||
            (typeof productData.image === "object" &&
                Object.keys(productData.image).length === 0)
        ) {
            newErrors.image = "Image is required";
        }

        if (!productData?.priceFrom || productData?.priceFrom < 0) {
            newErrors.priceFrom = "Price should be greater than 0";
        }

        if (!productData?.priceTo || productData?.priceTo < 0) {
            newErrors.priceTo = "Price should be greater than 0";
        }

        if (Number(productData?.priceFrom) > Number(productData?.priceTo)) {
            newErrors.priceTo = "Price To should be greater than Price From";
        }

        if (!selectedCategories || selectedCategories.length === 0) {
            newErrors.category = "At least 1 category should be select";
        }

        if (!selectedBrandCategories || !selectedBrandCategories?.id) {
            newErrors.brand = "Brand is required";
        }

        // if (!productData?.specification || productData?.specification.length === 0) {
        //     newErrors.specification = "At least one specification is required";
        // } else {
        //     const specErrors = productData.specification.map((item) => {
        //         let error = {};
        //         if (!item.label?.trim()) error.label = "Label required";
        //         if (!item.value?.trim()) error.value = "Value required";
        //         return error;
        //     });

        //     if (specErrors.some(err => Object.keys(err).length > 0)) {
        //         newErrors.specification = specErrors;
        //     }
        // }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handlePublish = async () => {
        if (!validateProduct()) return;

        setIsLoading(true);
        try {
            const payload = { ...productData,tax: undefined, categoryId: selectedCategories?.map(item => item.id), brandId: selectedBrandCategories?.id, status: 'published' };
            if (productId) {
                await updateProduct(productId, payload);
            } else {
                const response = await createProduct(payload);
                if (response?.success) {
                    navigate(`/product/${response?.data?.productId}`)
                }
            }
            setPublished(true);
            setDraft(false);
            setProductData({ ...productData, status: 'published' });
        } catch (error) {
            console.log("Error creating product:", error);
            if (error?.response?.data?.error?.message === 'Product slug already exists') {
                setErrors({ ...errors, slug: error?.response?.data?.error?.message })
            }
        } finally {
            setIsLoading(false);
        }
    };

    const handleDraft = async () => {
        if (!validateProduct()) return;

        setIsDraftLoading(true);
        try {
            const payload = { ...productData,tax: undefined, categoryId: selectedCategories?.map(item => item.id), brandId: selectedBrandCategories?.id, status: 'draft' };
            if (productId) {
                await updateProduct(productId, payload);
            } else {
                const response = await createProduct(payload);
                if (response?.success) {
                    navigate(`/product/${response?.data?.productId}`)
                }
            }
            setDraft(true);
            setPublished(false);
            setProductData({ ...productData, status: 'draft' });
            setIsDraftLoading(false);
            setIsLoading(false)
        } catch (error) {
            if (error?.response?.data?.error?.message === 'Product slug already exists') {
                setErrors({ ...errors, slug: error?.response?.data?.error?.message })
            }
        } finally {
            setIsDraftLoading(false);
        }
    };

    const handleChangeToDraft = async () => {
        // Update to draft
        if (published) {
            setIsLoading(true);
            try {
                const payload = { ...productData,tax: undefined, categoryId: selectedCategories?.map(item => item.id), brandId: selectedBrandCategories?.id, status: 'draft' };
                await updateProduct(productId, payload);
                setDraft(true);
                setPublished(false);
                setProductData({ ...payload, status: 'draft' });
                setIsPublishedOpen(false);
                setIsLoading(false);
            } catch (error) {
                if (error?.response?.data?.error?.message === 'Product slug already exists') {
                    setErrors({ ...errors, slug: error?.response?.data?.error?.message })
                }
                setIsLoading(false);
            }
        }
    };

    const handleChangeToPublish = async () => {
        if (draft) {
            setIsLoading(true);
            try {
                const payload = { ...productData,tax: undefined, categoryId: selectedCategories?.map(item => item.id), brandId: selectedBrandCategories?.id, status: 'published' };
                await updateProduct(productId, payload);
                setDraft(false);
                setPublished(true);
                setProductData({ ...payload, status: 'published' });
                setIsDraftOpen(false);
            } catch (error) {
                if (error?.response?.data?.error?.message === 'Product slug already exists') {
                    setErrors({ ...errors, slug: error?.response?.data?.error?.message })
                }
            }
            setIsLoading(false);
        }
    };

    const handelSingleDelete = async () => {
        // Delete product
        try {
            await deleteProducts([productId]);
            // Reset or redirect
        } catch (error) {
            console.error("Error deleting product:", error);
        }
    };

    const validateDraftProduct = () => {
        // Same as validateProduct for now
        return validateProduct();
    };

    const handleSlugChange = (e) => {
        handleChange(e);
        setIsSlugChanged(true)
        if (e.target.value === '') {
            setIsSlugChanged(false)
        }
    };

    const handleNameChange = (e) => {
        const { value } = e.target;

        setProductData(prev => {
            const updated = { ...prev, title: value };

            if (!isSlugChanged) {
                updated.slug = convertToSlug(value);
            }

            return updated;
        });
    };

    const handleSingleDelete = () => {
        setShowDeletePopup(true)
    }

    const confirmDelete = async () => {
        try {
            const response = await deleteProducts([productId]);
            if (response?.success) {
                navigate('/products/all');
            }
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <>
            <TopBar />
            <div className={styles.contentWrapper}>
                <div className={styles.newpageContent} >
                    <LeftSide
                        styles={styles}
                        productData={productData}
                        setProductData={setProductData}
                        handleNameChange={handleNameChange}
                        handleChange={handleChange}
                        handleSpecificationChange={handleSpecificationChange}
                        addSpecification={addSpecification}
                        deleteSpecification={deleteSpecification}
                        setErrorMessage={setErrors}
                        errorMessage={errors}
                        errors={errors}
                        setShowUploadMediaPopup={setShowUploadMediaPopup}
                        setUploadMediaPopupTab={setUploadMediaPopupTab}
                        setUploadMediaPopupFor={setUploadMediaPopupFor}
                        setSelectedImagesValidate={setSelectedImagesValidate}
                        setSelectedImageFileData={setSelectedImageFileData}
                        selectedImageFileData={selectedImageFileData}
                    />
                    <RightSidebar
                        styles={styles}
                        setShowUploadMediaPopup={setShowUploadMediaPopup}
                        setUploadMediaPopupTab={setUploadMediaPopupTab}
                        setUploadMediaPopupFor={setUploadMediaPopupFor}
                        productData={productData}
                        setProductData={setProductData}
                        changeSlug={changeSlug}
                        errorMessage={errors}
                        setErrorMessage={setErrors}
                        published={published}
                        draft={draft}
                        isPublishedOpen={isPublishedOpen}
                        setIsPublishedOpen={setIsPublishedOpen}
                        isDraftOpen={isDraftOpen}
                        setIsDraftOpen={setIsDraftOpen}
                        isLoading={isLoading}
                        isDraftLoading={isDraftLoading}
                        handlePublish={handlePublish}
                        handleDraft={handleDraft}
                        handleChangeToDraft={handleChangeToDraft}
                        handleChangeToPublish={handleChangeToPublish}
                        handelSingleDelete={handelSingleDelete}
                        productId={productId}
                        setIsDraftLoading={setIsDraftLoading}
                        setIsLoading={setIsLoading}
                        validateDraftProduct={validateDraftProduct}
                        handleSlugChange={handleSlugChange}
                        categoryList={categoryList}
                        brandList={brandList}
                        selectedCategories={selectedCategories}
                        setSelectedCategories={setSelectedCategories}
                        selectedBrandCategories={selectedBrandCategories}
                        setSelectedBrandCategories={setSelectedBrandCategories}
                        handleSingleDelete={handleSingleDelete}
                        selectedImageFileData={selectedImageFileData}
                        setSelectedImageFileData={setSelectedImageFileData}
                        selectedImagesValidate={selectedImagesValidate}
                        setSelectedImagesValidate={setSelectedImagesValidate}
                        selectedFeatureImage={selectedFeatureImage}
                    />
                </div>
            </div>
            {showUploadMediaPopup &&
                <UploadMediaPopup showUploadMediaPopup={showUploadMediaPopup} setShowUploadMediaPopup={setShowUploadMediaPopup} setSelectedProfileImage={setSelectedMedia} uploadMediaPopupFor={uploadMediaPopupFor} uploadMediaPopupTab={uploadMediaPopupTab} />
            }

            <DeleteConfirmationPopup
                showDeletePopup={showDeletePopup}
                setShowDeletePopup={setShowDeletePopup}
                reference={deletePopupRef}
                title={'product'}
                description={'Are you sure you want to delete this product? This action cannot be undone.'}
                confirmDelete={confirmDelete}
            />
        </>
    )
}

export default NewProduct